import {Component, forwardRef, Injector, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FooControlComponent} from "../foo-control/foo-control.component";

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FooNumberComponent),
  multi: true
};

@Component({
  selector: 'foo-number',
  templateUrl: './foo-number.component.html',
  styleUrls: ['./foo-number.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class FooNumberComponent extends FooControlComponent implements OnInit {
  constructor(
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

}
